import axios from 'axios';

const setupInterceptors = (context) => {
  // Add response interceptor
  context.$axios.interceptors.response.use(
    function(response) {
      // Handle success response
      if (!response.data.success) {
        // Extract error message based on the different conditions
        handleErrors(context, response.data);
      }
      return response;
    },
    function(error) {
      // Handle errors that are not a response (like network errors)
      if (error.response.data) {
        handleErrors(context, error.response.data);
      } else {
        const errorMessage = error.response
          ? JSON.stringify(error.response)
          : error.message;
        console.log(`An error occurred: ${errorMessage}`);
      }
      return Promise.reject(error);
    },
  );
};

// Signup uses this to show the "enter your current password" step instead of
// treating a taken mailbox as a hard failure.
export const isEmailTakenSignupResponse = (data) => {
  if (!data) return false;
  if (data.details?.reason === 'email_taken') return true;
  const msg = `${data.error || ''} ${data.result || ''}`;
  return /already in use|already exists|select a different email/i.test(msg);
};

const handleErrors = (context, data) => {
  if (isEmailTakenSignupResponse(data)) return;

  let customErrorMessage = '';
  if (data.result) {
    customErrorMessage = `An error occurred: ${data.result}`;
  } else if (data.error) {
    customErrorMessage = `An error occurred: ${data.error}`;
  } else if (data.error_message) {
    customErrorMessage = `An error occurred: ${data.error_message}`;
  } else if (data.errors) {
    data.errors.forEach((error) => {
      context.$toast.show(JSON.stringify(error), context.toasted_options.error);
    });
  }

  if (customErrorMessage) {
    context.$toast.show(customErrorMessage, context.toasted_options.error);
  }
};

const createAxiosInstance = (context) => {
  // Create the axios instance
  context.$axios = axios.create({
    baseURL: '',
  });

  // Setup interceptors with context
  setupInterceptors(context);

  return context.$axios;
};

export default createAxiosInstance;
